import axios from 'axios';
import { MergedBookingsResponse } from '../types/MergedBookings';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface MergedBookingsFilters {
  date?: string;
  start_date?: string;
  end_date?: string;
}

export const getMergedBookings = async (
  token: string,
  filters?: MergedBookingsFilters
): Promise<MergedBookingsResponse> => {
  try {
    const params = new URLSearchParams();
    if (filters?.date) params.append('date', filters.date);
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);

    const response = await api.get('/merged-bookings', {
      headers: {
        Authorization: token,
      },
      params,
    });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching merged bookings:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch merged bookings');
  }
};
